<mat-form-field [subscriptSizing]="subscriptSizing()">
  <mat-label>
    {{ label() }}
  </mat-label>
  <mat-select [(ngModel)]="value" [disabled]="disabled()" canSelectNullableOptions [multiple]="multiple()">
    @for (option of options(); track $index) {
      <mat-option [value]="option" [disabled]="isOptionDisabled()(option)">
        @if (displayTemplate()) {
          <ng-container *ngTemplateOutlet="displayTemplate()!; context: { $implicit: option }"></ng-container>
        }
      </mat-option>
    } @empty {
      <mat-option disabled>Keine Optionen verfügbar</mat-option>
    }
  </mat-select>
</mat-form-field>
